module.exports = __webpack_public_path__ + "img/DAF.5677e4c5.svg";